/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Workout_Live_Implausible_SlipInputs */

const en_us2_workout_live_implausible_slip = /** @type {(inputs: Workout_Live_Implausible_SlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Did you mean ${i?.value}?`)
};

const pt_br2_workout_live_implausible_slip = /** @type {(inputs: Workout_Live_Implausible_SlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não seria ${i?.value}?`)
};

const es_419_workout_live_implausible_slip = /** @type {(inputs: Workout_Live_Implausible_SlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Quisiste decir ${i?.value}?`)
};

const pt_pt2_workout_live_implausible_slip = /** @type {(inputs: Workout_Live_Implausible_SlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não seria ${i?.value}?`)
};

const fr_fr2_workout_live_implausible_slip = /** @type {(inputs: Workout_Live_Implausible_SlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu voulais dire ${i?.value} ?`)
};

const de_de2_workout_live_implausible_slip = /** @type {(inputs: Workout_Live_Implausible_SlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meintest du ${i?.value}?`)
};

const it_it2_workout_live_implausible_slip = /** @type {(inputs: Workout_Live_Implausible_SlipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Intendevi ${i?.value}?`)
};

/**
* | output |
* | --- |
* | "Did you mean {value}?" |
*
* @param {Workout_Live_Implausible_SlipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_slip = /** @type {((inputs: Workout_Live_Implausible_SlipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_SlipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_slip(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_slip(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_slip(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_slip(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_slip(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_slip(inputs)
	return en_us2_workout_live_implausible_slip(inputs)
});
export { workout_live_implausible_slip as "workout-live.implausible_slip" }